import { createBrowserRouter } from "react-router-dom";
import { App } from "./App";
import { ViewportProvider } from "./contexts";

/** Data router for Phase 3a; route blocking is added separately in Phase 3b. */
export const appRouter = createBrowserRouter(
    [
        {
            path: "/*",
            element: (
                <ViewportProvider>
                    <App />
                </ViewportProvider>
            ),
        },
    ],
    {
        future: {
            v7_startTransition: true,
            v7_relativeSplatPath: true,
        },
    }
);
